<script setup lang="ts">
import AppContainer from './views/AppContainer.vue';
  import 'primeicons/primeicons.css';
  import { ref } from 'vue';

  const isMobile = ref(window.innerWidth <= 768);
  const handleResize = () => {
    isMobile.value = window.innerWidth <= 768;
  };
  window.addEventListener('resize', handleResize);
  const handleOrientationChange = () => {
    isMobile.value = window.innerWidth <= 768;
  };
  window.addEventListener('orientationchange', handleOrientationChange);
</script>

<template>
  <div class="app">
    <AppContainer :isMobile="isMobile"> </AppContainer>
  </div>
</template>

<style>
  @import url('/assets/styles/index.css');
  @import url('/assets/animatecss/animate.min.css');
</style>